export default {
    meta: {
        title: '展位详情',
        isShowNav: true,
        activeMenu: '/booth',
        crumbs: {
            path: ['/booth'],
            name: ['展位管理'],
        },
    },
};
